import { useMemo } from 'react';
import { CatalogItem } from '../../../redux/api/fymAPI.types';
import { buildServiceRows, ServiceRow } from './servicesPanelRows';

/**
 * The rows of "Where it plays": the links of the catalog row. The uploads of a service are not
 * rows: each service with uploads gives its extras box (design service-extras a1).
 */
export function useServicesPanelRows({ item, readOnly }: { item: CatalogItem; readOnly: boolean }): ServiceRow[] {
  return useMemo(() => buildServiceRows({ serviceLinks: item.serviceLinks, readOnly }), [item.serviceLinks, readOnly]);
}
